


import { Component, Vue } from 'vue-property-decorator';
import Cookies from 'js-cookie';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_CSRF: CSRF } = process.env;

const API = {
  get_token: `${FCAPI}/vm/setting/passport/new`,
};

@Component
export default class Login extends Vue {
  async mounted() {
    await this.$axios.get(API.get_token);
    if (Cookies.get(CSRF)) {
      this.$router.go(-1);
    }
  }
}
